var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientlistGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 2C3.567 2 2 3.567 2 5.5C2 7.433 3.567 9 5.5 9C7.433 9 9 7.433 9 5.5C9 3.567 7.433 2 5.5 2ZM3.75 9.875C1.817 9.875 0.25 11.442 0.25 13.375V14.25C0.25 15.2165 1.0335 16 2 16H9C9.9665 16 10.75 15.2165 10.75 14.25V13.375C10.75 11.442 9.183 9.875 7.25 9.875H3.75Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0945 8.04234C10.5122 7.2891 10.75 6.42232 10.75 5.5C10.75 4.57768 10.5122 3.7109 10.0945 2.95766C10.7216 2.36405 11.5683 2 12.5 2C14.433 2 16 3.567 16 5.5C16 7.433 14.433 9 12.5 9C11.5683 9 10.7216 8.63595 10.0945 8.04234ZM12.0318 16C12.3296 15.4852 12.5 14.8875 12.5 14.25V13.375C12.5 12.0304 11.9945 10.8038 11.1632 9.875H14.25C16.183 9.875 17.75 11.442 17.75 13.375V14.25C17.75 15.2165 16.9665 16 16 16H12.0318Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientlistGrey);
export default __webpack_public_path__ + "static/media/patientlistGrey.7363a12ea145fc49287b7536664fd779.svg";
export { ForwardRef as ReactComponent };